import { useQuery } from "@tanstack/react-query";
import { getNiceToken } from "src/api/nice";
import { QUERY_KEYS } from "../constants/queryKeys";
const useGetNiceAuthData = (param)=>{
    let { returnUrl , enabled  } = param;
    return useQuery({
        queryKey: [
            QUERY_KEYS.NICE_AUTH_DATA
        ],
        queryFn: ()=>getNiceToken({
                returnUrl
            }),
        enabled
    });
};
export default useGetNiceAuthData;
